import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild
} from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/take';

import {
  ListViewComponent
} from '../list/list-view.component';

import {
  AsyncList
} from 'microedge-rxstate/dist';

import {
  ListItemModel
} from '../list/state/items/item.model';

import {
  ListState,
  ListStateDispatcher
} from '../list/state';

import {
  ChecklistState,
  ChecklistStateDispatcher,
  ChecklistStateModel
} from './state';

import {
  ListViewChecklistItemsLoadAction
} from './state/items/actions';

import {
  ListViewChecklistItemModel
} from './state/items/item.model';

import {
  ListToolbarItemModel
} from '../list/state/toolbar/toolbar-item.model';

import {
  ListToolbarSetTypeAction
} from '../list/state/toolbar/actions';

import {
  getData
} from '../list/helpers';

import {
  ListSelectedSetItemSelectedAction,
  ListSelectedSetItemsSelectedAction
} from '../list/state/selected/actions';


export class SkyListViewChecklistComponent extends ListViewComponent implements AfterViewInit, OnDestroy {
  
  set name(value: string) {
    this.viewName = value;
  }

  
  public search: (data: any, searchText: string) => boolean = this.searchFunction();

  /* tslint:disable */
  
  public labelFieldSelector: string = 'label';
  /* tslint:enable */

  
  public description: string = 'description';

  
  public set selectMode(value: string) {
    this._selectMode = value;
    this.updateActions();
  }

  public get selectMode(): string {
    return this._selectMode;
  }

  
  private selectAllTemplate: TemplateRef<any>;

  
  private clearSelectionsTemplate: TemplateRef<any>;

  private hasSelectToolbarItems = false;
  private ngUnsubscribe = new Subject();

  private _selectMode = 'multiple';

  constructor(
    state: ListState,
    private dispatcher: ListStateDispatcher,
    private checklistState: ChecklistState,
    private checklistDispatcher: ChecklistStateDispatcher
  ) {
    super(state, 'Checklist View');

    let lastUpdate: any;
    Observable.combineLatest(
      this.state.map(s => s.items).distinctUntilChanged(),
      (items: AsyncList<ListItemModel>) => {
        let dataChanged = lastUpdate === undefined || items.lastUpdate !== lastUpdate;
        lastUpdate = items.lastUpdate;
        let newItems = items.items.map(item => {
          return new ListViewChecklistItemModel(item.id, {
            label:
              this.labelFieldSelector ? getData(item.data, this.labelFieldSelector) : undefined,
            description:
              this.description ? getData(item.data, this.description) : undefined
          });
        });

        this.checklistDispatcher.next(
          new ListViewChecklistItemsLoadAction(newItems, true, dataChanged, items.count)
        );
      }
    )
    .takeUntil(this.ngUnsubscribe)
    .subscribe();
  }

  public onViewActive() {
    if (this.search !== undefined) {
      this.dispatcher.searchSetFunctions([this.search]);
    }

    let fieldSelectors: Array<string> = [];
    if (this.labelFieldSelector) {
      fieldSelectors.push(this.labelFieldSelector);
    }

    if (this.description) {
      fieldSelectors.push(this.description);
    }

    this.dispatcher.searchSetFieldSelectors(fieldSelectors);

    this.dispatcher.next(new ListToolbarSetTypeAction('search'));
  }

  public ngAfterViewInit() {
    this.updateActions();
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  get items(): Observable<ListViewChecklistItemModel[]> {
    return this.checklistState.map(state => state.items.items);
  }

  public searchFunction() {
    return (data: any, searchText: string) => {
      if (this.labelFieldSelector !== undefined) {
        let label = getData(data, this.labelFieldSelector);
        /* tslint:disable:no-null-keyword */
        if (
          label !== undefined &&
          label !== null &&
          label.toString().toLowerCase().indexOf(searchText) !== -1
        ) {
          return true;
        }
        /* tslint:enable:no-null-keyword */
      }

      if (this.description !== undefined) {
        let description = getData(data, this.description);
        /* tslint:disable:no-null-keyword */
        if (
          description !== undefined &&
          description !== null &&
          description.toString().toLowerCase().indexOf(searchText) !== -1
        ) {
          return true;
        }
        /* tslint:enable:no-null-keyword */
      }

      return false;
    };
  }

  public itemSelected(id: string): Observable<boolean> {
    return this.state.map(state => state.selected.item.selectedIdMap.get(id));
  }

  public setItemSelection(item: ListItemModel, event: any) {
    this.dispatcher.next(new ListSelectedSetItemSelectedAction(item.id, event.checked));
  }

  public singleSelectRowClick(item: ListItemModel) {
    this.dispatcher.next(new ListSelectedSetItemsSelectedAction([item.id], true, true));
  }

  public clearSelections() {
    this.state.map(state => state.items.items)
      .take(1)
      .subscribe(items => {
        this.dispatcher
          .next(new ListSelectedSetItemsSelectedAction(items.map(item => item.id), false, false));
      });
  }

  public selectAll() {
    this.state.map(state => state.items.items)
      .take(1)
      .subscribe(items => {
        this.dispatcher
          .next(new ListSelectedSetItemsSelectedAction(items.map(item => item.id), true, false));
      });
  }

  private updateActions() {
    const selectAllId = 'select-all';
    const clearAllId = 'clear-all';

    switch (this.selectMode) {
      case 'single':
        this.dispatcher.toolbarRemoveItems([selectAllId, clearAllId]);
        this.hasSelectToolbarItems = false;
        break;
      default:
        if (!this.hasSelectToolbarItems) {
          this.dispatcher.toolbarAddItems([
            new ListToolbarItemModel(
              {
                id: 'select-all',
                template: this.selectAllTemplate,
                location: 'right',
                index: 500,
                view: this.id
              }
            ),
            new ListToolbarItemModel(
              {
                id: 'clear-all',
                template: this.clearSelectionsTemplate,
                location: 'right',
                index: 500,
                view: this.id
              }
            )
          ]);

          this.hasSelectToolbarItems = true;
        }
        break;
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-list-view-checklist',
  template: `<div class="sky-list-view-checklist" *ngIf="active | async">
  <div [ngSwitch]="selectMode">
    <ng-template ngSwitchCase="single">
      <div role="radiogroup">
        <sky-list-view-checklist-item
          *ngFor="let item of items | async"
          [item]="item"
          [attr.sky-cmp-id]="item.id">
            <button
              role="radio"
              [attr.aria-checked]="(itemSelected(item.id) | async) || false"
              type="button"
              class="sky-list-view-checklist-single-button"
              [ngClass]="{ 'sky-list-view-checklist-row-selected' : (itemSelected(item.id) | async) }"
              (click)="singleSelectRowClick(item)">
              <div class="sky-emphasized" *ngIf="item.label">{{item.label}}</div>
              <div *ngIf="item.description">{{item.description}}</div>
            </button>
        </sky-list-view-checklist-item>
      </div>
    </ng-template>

    <ng-template ngSwitchDefault>
      <sky-list-view-checklist-item
        *ngFor="let item of items | async"
        [item]="item"
        [attr.sky-cmp-id]="item.id">
          <sky-checkbox
            [checked]="itemSelected(item.id) | async"
            (change)="setItemSelection(item, $event)">
            <sky-checkbox-label>
              <div class="sky-emphasized" *ngIf="item.label" [attr.title]="item.label">
                {{item.label}}
              </div>
              <div *ngIf="item.description" [attr.title]="item.description">
                {{item.description}}
              </div>
            </sky-checkbox-label>
          </sky-checkbox>
        </sky-list-view-checklist-item>
    </ng-template>
  </div>
</div>


<ng-template #selectAllTemplate>
  <button
    class="sky-btn sky-btn-link sky-list-view-checklist-select-all"
    (click)="selectAll(); false"
  >
    {{'checklist_select_all' | skyResources}}
  </button>
</ng-template>

<ng-template #clearSelectionsTemplate>
  <button
    class="sky-btn sky-btn-link sky-list-view-checklist-clear-all"
    (click)="clearSelections(); false"
  >
    {{'checklist_clear_all' | skyResources}}
  </button>
</ng-template>
`,
  styles: [`.sky-list-view-checklist /deep/ .sky-checkbox-wrapper {
  display: flex;
  align-items: center;
}

.sky-list-view-checklist /deep/ .sky-checkbox-wrapper > .sky-checkbox, .sky-list-view-checklist /deep/ .sky-checkbox-wrapper > input {
  flex: 1;
  max-width: 22px;
}
`],
  providers: [
    /* tslint:disable */
    { provide: ListViewComponent, useExisting: forwardRef(() => SkyListViewChecklistComponent)},
    /* tslint:enable */
    ChecklistState,
    ChecklistStateDispatcher,
    ChecklistStateModel
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ListState, },
{type: ListStateDispatcher, },
{type: ChecklistState, },
{type: ChecklistStateDispatcher, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'name': [{ type: Input },],
'search': [{ type: Input },],
'labelFieldSelector': [{ type: Input, args: ['label', ] },],
'description': [{ type: Input },],
'selectMode': [{ type: Input },],
'selectAllTemplate': [{ type: ViewChild, args: ['selectAllTemplate', ] },],
'clearSelectionsTemplate': [{ type: ViewChild, args: ['clearSelectionsTemplate', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
